import { Collapse, ListSubheader } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { PagesConfig } from "PagesConfig";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getUserRoles } from "../../config/azureConfig";
import { getIcon } from "../../icon/icon";
import { UserRoles } from "../../state/constants/UserRoles";
import styles from "./DrawerItems.module.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#EBEBEB",
  },
}));

function DrawerItems(props) {
  const [open, setOpen] = useState(true);
  const [items, setItems] = useState([]);
  const [t, i18n] = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    generateItems();
  }, []);

  useEffect(() => {
    generateItems()
    return () => {
      setItems([])
    }
  }, [i18n.language])

  function handleClick(route) {
    props.history.push(route);
    setOpen(!open);

    props.handleClick(false);
  }

  function generateItems() {
    const { COMMERICAL, IT_ADMIN, DISTRIBUTOR } = UserRoles;
    const flavour = process.env.REACT_APP_FLAVOUR;
    getUserRoles((userRoles) => {
      let newItems = [];

      const pagesConfig = PagesConfig()

      Object.values(pagesConfig).forEach(page => {
        if (page.flavours.length == 0 || page.flavours.includes(flavour)) {
          newItems.push({
            icon: page.icon != null ? getIcon(page.icon, styles.icon) : undefined,
            name: page.name,
            route: page.route,
            type: page.type,
            roles: page.roles,
          })
        }
      })
      
      const filteredItems = newItems.filter((item) => {
        let success = item.roles.length === 0;

        for (let i = 0; i < item.roles.length; i++) {
          if (success) {
            return success;
          }
          success = userRoles.includes(item.roles[i]);
        }

        return success;
      })
      setItems(filteredItems);
    });
  }

  function isActive(route) {
    return props.history.location.pathname.endsWith(route);
  }

  function renderItem(item) {
    return (
      <ListItem
        key={item.route}
        selected={isActive(item.route)}
        onClick={() => handleClick(item.route)}
        button
      >
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText primary={item.name} />
      </ListItem>
    );
  }

  return (
    <List component="nav" aria-labelledby="nested-list-subheader">
      {items.map((item) => {
        if (item.type === "header") {
          return (
            <ListSubheader
              classes={{
                root: classes.root,
              }}
              key={item.route}
            >
              {item.name}
            </ListSubheader>
          );
        } else if (item.type === "link") {
          if (!!item.children) {
            return (
              <Fragment>
                <ListItem key={item.route} button onClick={handleClick}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.name} />
                  {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  {item.children.map((childItem) => {
                    return (
                      <List
                        component="div"
                        disablePadding
                      >
                        {renderItem(childItem)}
                      </List>
                    );
                  })}
                </Collapse>
              </Fragment>
            );
          } else {
            return renderItem(item);
          }
        }
      })}
    </List>
  );
}

export default React.memo(DrawerItems);
